// Public pages
import ShareDetail from './shares/detail'

export default {
  ShareDetail
}